<template>
    <div id="brandBoardGlobalSettings">
      <component :is="brandBoardGlobalSettingsModal" v-bind="brandBoardGlobalSettingsProps" v-if="brandBoardGlobalSettingsModal" />
    </div>
  </template>
  <script lang="ts">
  import { useEmitter } from '../../composition/useEmitter'
  import { defineComponent, markRaw } from 'vue'
  import { useAppContext } from '../../composition/useAppContext'
  import { loadRemote } from '@module-federation/runtime'
  import GlobalSettingsEvents from '../../../events/GlobalSettings'
  import { defineAsyncMicroApp } from '@gohighlevel/ghl-module-federation-plugin'

  let isMounted = false
  
  export default defineComponent({
    data() {
      return {
        brandBoardGlobalSettingsModal: null,
        brandBoardGlobalSettingsProps: null,
      }
    },
    mounted() {
      // Instead of mounting on component mount, listen for the brandboard event
      const emitter = useEmitter()
      // this.mountGlobalSettings()
      emitter.on(GlobalSettingsEvents.OPEN_GLOBAL_SETTINGS, this.mountGlobalSettings)
    },
    beforeUnmount() {
      // Remove the event listener
      const emitter = useEmitter()
      emitter.off(GlobalSettingsEvents.OPEN_GLOBAL_SETTINGS)
      this.unmountGlobalSettings()
      isMounted = false
      
    },
    methods: {
      async mountGlobalSettings() {
        if (isMounted) return
        this.unmountGlobalSettings()
        try {
          const [brandBoardGlobalSettingsModal] = await defineAsyncMicroApp('brandBoardsApp', ['GlobalSettings'])
          
          const emitter = useEmitter()
          const storageLocale = localStorage.getItem('locale')
          const location = this.$route.params.location_id
          
          this.brandBoardGlobalSettingsProps = {
            emitter,
            location,
            locale: storageLocale || 'en'
          }
          this.brandBoardGlobalSettingsModal = markRaw(brandBoardGlobalSettingsModal)
          isMounted = true
        } catch(e) {
          console.error(e)
        }
      },
      async unmountGlobalSettings() {
        this.brandBoardGlobalSettingsModal = null
        this.brandBoardGlobalSettingsProps = null
      },
    },
  })
  </script>